import { Modal } from 'almanac-ui/Modal'
import ImageMenuModalStyles from '../ImageMenuModal.module.scss'
import Styles from './BrandKitMedia.module.scss'
import { Button } from 'blaze-ui/Button'
import { ArrowLeft } from 'blaze-ui/icons'
import { useImageMenuContext } from '../ImageMenuContext'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Actions } from '../ImageMenuModal'
import { ScrollContainer } from 'components/ImagePickerModal/ScrollContainer/ScrollContainer'
import { Grid } from 'components/ImagePickerModal/Grid/Grid'
import { ImageThumbnail } from 'components/ImagePickerModal/ImageThumbnail/ImageThumbnail'
import { useInfiniteBrandKitMediaFiles } from 'hooks/queries/brandKits/useInfiniteBrandKitMediaFiles'
import { collectResults } from 'utils/query'
import { getMediaFiles } from 'components/Design/UploadsTab/getMediaFiles'
import { AlmanacFile } from 'types'
import { Select } from 'components/Select/Select'
import { useBrandKits } from 'hooks/queries/brandKits/useBrandKits'
import { Item } from 'components/Menu/MenuItem'
import { BrandKitLogo } from 'screens/BrandKit/BrandKitLogo/BrandKitLogo'
import InfiniteScroll from 'common/InfiniteScroll/InfiniteScroll'

export const BrandKitMedia = () => {
  const { setProvider, selectedImages, toggleSelectedImage, brandKitId, setBrandKitId, accept } = useImageMenuContext()
  const mediaFilesQuery = useInfiniteBrandKitMediaFiles({
    brandKitId,
    items: 18,
    order_by: 'recent',
    mime_types: accept,
  })
  const brandKitMediaFiles = collectResults(mediaFilesQuery, (data) => data.media_files)
  const mediaFiles = getMediaFiles(brandKitMediaFiles as AlmanacFile[], accept)
  const { data: brandKits } = useBrandKits({
    select: (data) => data.filter((brandKit) => brandKit.media_files.length > 0),
    cacheTime: 1000 * 60 * 5,
  })

  if (!brandKits) {
    return null
  }

  return (
    <>
      <Modal.Header className={ImageMenuModalStyles.header}>
        <div className={Styles.header}>
          <Button variant="tertiary" size="xs" frontIcon={ArrowLeft} onPress={() => setProvider('')} />
          <Heading level={3}>Brand Kits</Heading>
          <Select selectedKey={`${brandKitId}`} onSelectionChange={(key) => setBrandKitId(parseInt(key as string))}>
            {brandKits?.map((brandKit) => (
              <Item key={brandKit.id} textValue={brandKit.name}>
                <div className={Styles.brandKitContainer}>
                  <BrandKitLogo brandKit={brandKit} size={20} />
                  {brandKit.name}
                </div>
              </Item>
            ))}
          </Select>
        </div>
        <Actions />
      </Modal.Header>
      <Modal.Content className={Styles.content}>
        <ScrollContainer>
          <Grid.Root breakpointCols={4}>
            {mediaFiles.map((mediaFile) => (
              <div key={mediaFile.id} className={Styles.mediaContainer}>
                <ImageThumbnail
                  image={{ ...mediaFile, url: mediaFile.thumbnail_url || '' }}
                  onToggleSelect={(image) => toggleSelectedImage({ ...image, provider: 'brandKits' })}
                  isSelected={selectedImages.some((i) => i.url === mediaFile.thumbnail_url)}
                  duration={mediaFile.duration}
                />
              </div>
            ))}
          </Grid.Root>
          {mediaFilesQuery.hasNextPage && (
            <div className={Styles.infiniteLoader}>
              <InfiniteScroll hasMore={mediaFilesQuery.hasNextPage} loadMore={mediaFilesQuery.fetchNextPage} />
            </div>
          )}
        </ScrollContainer>
      </Modal.Content>
    </>
  )
}
